export default {
  setToken(value) {
    window.localStorage.setItem("token", value);
  },

  setUser(user) {
    window.localStorage.setItem(
      "user",
      JSON.stringify({
        id: user.id,
        name: user.name,
        email: user.email
      })
    );
  },

  setTimePeriods(data) {
    window.localStorage.setItem(
      "timePeriods",
      JSON.stringify({
        timePeriods: data.timePeriods
      })
    );
  },

  setGlobalTimePeriod(data) {
    window.localStorage.setItem(
      "globalTimePeriod",
      JSON.stringify({
        timePeriod: data.timePeriod
      })
    );
  },

  getToken() {
    let token = window.localStorage.getItem("token");
    if (!token) {
      return null;
    } else {
      return token;
    }
  },

  getUser() {
    let user = window.localStorage.getItem("user");
    if (!user) {
      this.destroyToken();
      return null;
    } else {
      return user;
    }
  },

  getGlobalTimePeriod() {
    let globalTimePeriod = window.localStorage.getItem("globalTimePeriod");
    if (!globalTimePeriod) {
      return null;
    } else {
      return globalTimePeriod;
    }
  },

  getTimePeriods() {
    let timePeriods = window.localStorage.getItem("timePeriods");
    if (!timePeriods) {
      return [];
    } else {
      return timePeriods;
    }
  },

  destroyToken() {
    window.localStorage.removeItem("token");
  },

  destroyUser() {
    window.localStorage.removeItem("user");
  },

  destroyTimePeriods() {
    window.localStorage.removeItem("timePeriods");
  },

  destroyGlobalTimePeriod() {
    window.localStorage.removeItem("globalTimePeriod");
  },

  destroySbMain() {
    window.localStorage.removeItem("sbMain");
  },

  destroyExportJob() {
    window.localStorage.removeItem("exportJob");
  },

  logout() {
    this.destroyUser();
    this.destroySbMain();
    this.destroyExportJob();
    this.destroyTimePeriods();
    this.destroyGlobalTimePeriod();
    this.destroyToken();
  },

  isAuthenticated() {
    if (this.getToken()) {
      return true;
    }
    return false;
  }
};
